module.exports = __webpack_public_path__ + "static/media/SHIBX.4a52558f.png";